let mapid = document.querySelector('#map');
let mapProjects = document.querySelector('#mapProjects');

if (mapid) {
	mapboxgl.accessToken = 'pk.eyJ1Ijoienpvb2ZlIiwiYSI6ImNrbzAybGdsZDBiZnkydW1mc3V3bTdtNzYifQ._HoPe4hknNpjicKuH-A3sQ';

	const monument = [37.671004, 55.771915];

	const map = new mapboxgl.Map({
		container: 'map',
		style: 'mapbox://styles/zzoofe/cko02xerm0jrp17nbzo1cjhf2',
		center: monument,
		zoom: 15.33,
		scrollZoom: false,
	});

	const el = document.createElement('div');
	el.id = 'marker';

	new mapboxgl.Marker(el)
		.setLngLat(monument)
		.addTo(map);
}

if (mapProjects) {
	mapboxgl.accessToken = 'pk.eyJ1Ijoienpvb2ZlIiwiYSI6ImNrbzAybGdsZDBiZnkydW1mc3V3bTdtNzYifQ._HoPe4hknNpjicKuH-A3sQ';
	const monument = [37.671004, 55.771915];

	const map = new mapboxgl.Map({
		container: 'mapProjects',
		style: 'mapbox://styles/zzoofe/cko02xerm0jrp17nbzo1cjhf2',
		center: monument,
		zoom: 15.33,
		scrollZoom: false,
	});

	const popup = new mapboxgl.Popup({offset: 25}).setHTML(
		'<span>АИС "Мед"</span> Единый Региональный оператор по обращению с твёрдыми коммунальными отходами на территории Омской области',
	);

	const el = document.createElement('div');
	el.id = 'marker';

	new mapboxgl.Marker(el)
		.setLngLat(monument)
		.setPopup(popup)
		.addTo(map);
}
